module.exports = __webpack_public_path__ + "static/sign-up-form-1-6-36fb412d1bc6f0457c95f976ed7a3d31.png";